import React, { useCallback, useState } from 'react';
import { BusinessHeaderWrapper } from './BusinessHeader.style';
import Button from '../../molecules/Button';
import Field from '../Field';
import { CiSearch } from 'react-icons/ci';
import Select from '../../molecules/Select';
import AddBusinessModal from '../AddBusinessModal';
import CenterModal from '../../molecules/Modal/CenterModal';
import SuccessModal from '../SuccessModal';
import { debounce } from '../../../helpers/common';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

export const FilterOptions = [
  {
    value: '',
    label: 'All',
  },
  {
    value: 'Active',
    label: 'Active',
  },
  {
    value: 'Deactivated',
    label: 'Deactivated',
  },
];
const BusinessHeader = ({ setSearchQuery, heading, placeholder = 'Search Business' }) => {
  const { hasPermission } = useContextHook(AuthContext, ['hasPermission']);

  const [modal, setModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleBusinessSubmit = e => {
    setSuccessModal(true);
    setModal(false);
  };
  const debouncedSetSearchQuery = useCallback(
    debounce(query => {
      setSearchQuery(_ => ({ ..._, searchText: query }));
    }, 200),
    [],
  );
  return (
    <>
      {/* ------------------- Modal Start ------------------- */}

      <CenterModal width="666" title="Add New Business" open={modal} setOpen={setModal}>
        <AddBusinessModal handleSubmit={handleBusinessSubmit} />
      </CenterModal>

      <CenterModal width="580" open={successModal} setOpen={setSuccessModal}>
        <SuccessModal
          heading="Business Created Successfully!"
          para="your business creation is successfully completed, now you can create multiple stores in it."
          btnText="Go Back!"
          btnClick={() => setSuccessModal(false)}
        />
      </CenterModal>

      {/* ------------------- Modal End ------------------- */}

      <BusinessHeaderWrapper>
        <div className="heading-wrap">
          <h2 className="heading">{heading}</h2>
        </div>
        <div className="filters">
          <div className="Search">
            <Field
              type="search"
              rounded
              lg
              name="search"
              placeholder={placeholder}
              prefix={<CiSearch className="icon" />}
              onChange={({ target: { value } }) => {
                debouncedSetSearchQuery(value);
              }}
            />
          </div>
          <div className="filter-options">
            <Select
              options={FilterOptions}
              placeholder="Status.."
              onChange={e => setSearchQuery(_ => ({ ..._, filterStatus: e?.target?.value?.value }))}
            />
          </div>
          {hasPermission('business.create-business') && (
            <Button variant="primary" width="145px" onClick={() => setModal(true)}>
              + Add Business
            </Button>
          )}
        </div>
      </BusinessHeaderWrapper>
    </>
  );
};

export default BusinessHeader;
